import { format } from 'date-fns';
import { telemetry } from '../../api/client';
import { lokiToFaultRows } from '../mapping';
import type { FaultsPanelConfig } from '../types';
import { PanelEmpty, PanelError, PanelSkeleton } from './chrome';
import { usePanelQuery } from './usePanelQuery';

export interface FaultsPanelProps {
  panel: FaultsPanelConfig;
  timeRange: string;
  refreshMs: number;
}

export function FaultsPanel({ panel, timeRange, refreshMs }: FaultsPanelProps) {
  const { data, isLoading, isError, refetch } = usePanelQuery(
    ['telemetry', 'faults', panel.serials],
    timeRange,
    refreshMs,
    ({ start, end }) => telemetry.faults({ serials: panel.serials, start, end }),
  );

  if (isLoading) return <PanelSkeleton />;
  if (isError) return <PanelError onRetry={() => void refetch()} />;

  const rows = lokiToFaultRows(data?.events ?? []);
  if (rows.length === 0) return <PanelEmpty />;

  return (
    <div className="overflow-y-auto h-full">
      <ul className="divide-y divide-surface-2/60">
        {rows.map((row, i) => (
          <li key={`${row.ts}-${i}`} className="flex items-baseline gap-2 px-2 py-1">
            <span className="text-gray-500 text-xs whitespace-nowrap">
              {format(row.ts, 'MMM d HH:mm:ss')}
            </span>
            <span className="rounded bg-surface-2 px-1.5 py-0.5 text-[10px] text-gray-400 whitespace-nowrap">
              {row.serial}
            </span>
            <span className="text-gray-300 text-xs font-mono truncate">{row.line}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
